import { SignInRequired } from "@/components/SignInRequired";
import { useAuth } from "@/contexts/AuthContext";
import {
  consumePostLoginPath,
  getSafeReturnTo,
  rememberPostLoginPath,
} from "@/lib/auth-navigation";
import Seo from "@/components/seo/Seo";
import { useEffect } from "react";
import { useLocation } from "wouter";

export default function Login() {
  const { user, userProfile, loading } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    const requestedPath = getSafeReturnTo(
      new URLSearchParams(window.location.search).get("returnTo"),
      "",
    );
    if (requestedPath) rememberPostLoginPath(requestedPath);
  }, []);

  useEffect(() => {
    if (loading || !user || !userProfile) return;
    setLocation(
      userProfile.nicknameRequired
        ? "/nickname/setup"
        : consumePostLoginPath(),
    );
  }, [loading, setLocation, user, userProfile]);

  return (
    <>
      <Seo
        title="로그인 — OZK"
        description="OZK에 로그인해 질문, 경험 공유, 모임 참여와 업체 관리 기능을 이용하세요."
        path="/login"
      />
      <SignInRequired
        title="OZK 로그인"
        description="로그인하면 현재 계정으로 질문과 경험을 작성하고, 모임 참여와 알림 기능을 이용할 수 있습니다."
        backHref="/"
        backLabel="홈으로"
        initiallyOpen
      />
    </>
  );
}
